
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import pc from './pc/categorias.vue';
    import movil from './pc/categorias.vue';

    @Component( {
        name: "Componente",
        props: {},
        components: { pc, movil }
    } )
    export default class Componente extends Vue
    {



    }
